<template>
  <v-dialog
    v-model="dialog"
    width="450"
  >
    <v-card
      class="text-centerd"
    >
      <v-avatar
        size="100%"
        tile
      >
        <img
          :src="imageUrl"
        />
      </v-avatar>
      <v-expand-transition mode="out-in">
        <v-card v-for="item in results" :key="item.id" class="ma-1">
          <v-list-item two-line>
            <v-list-item-avatar
              tilee
              size="55"
              color="grey"
            >{{ item.similarity | number }}</v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-h5">
                {{ item.person.name }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ item.person.last_name }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-expand-transition>
      <v-card-actions
        v-if="showIdentifyBtn"
      >
        <v-spacer></v-spacer>
        <v-btn
          outlined
          color="grey"
          @click="dialog = !dialog"
        >
          Cerrar
        </v-btn>
        <v-btn
          depressed
          color="success"
          @click="indentifyPerson"
          :loading="loading"
          :disabled="loaded"
        >
          Identificar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import types from '@/types';

export default {

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    imageUrl: {
      type: String,
      default: null,
    },
    showIdentifyBtn: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      results: [],
      loading: false,
      loaded: false,
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  watch: {
    dialog(value) {
      if (!value) {
        this.results = [];
        this.loaded = false;
      }
    },
  },

  methods: {
    ...mapActions({
      [types.SEARCH_BY_IMAGE]: `${types.PERSON}/${types.SEARCH_BY_IMAGE}`,
    }),
    imageUrlToBase64(url) {
      return fetch(url)
        .then((response) => response.blob()) // Convert to blob
        .then((blob) => new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result.split(',')[1]); // Get base64 string
          reader.readAsDataURL(blob);
        }));
    },
    async indentifyPerson() {
      this.loading = true;
      this[types.SEARCH_BY_IMAGE]({ image: await this.imageUrlToBase64(this.imageUrl) })
        .then((response) => {
          this.results = response.data;
        })
        .finally(() => {
          this.loading = false;
          this.loaded = true;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/IdentifyComponent.vue